import React from "react";
import { useSelector } from "react-redux";
import { Paper } from "@mui/material";
import FirstStepMainBody from "./Steps/FirstStepMainBody";
import SecondStepMainBody from "./Steps/SecondStepMainBody";
import ThirdStepMainBody from "./Steps/ThirdStepMainBody";

const TemplateMainBody = () => {
  const { activeStep } = useSelector((state) => state.template);

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return <FirstStepMainBody />;
      case 1:
        return <SecondStepMainBody />;
      case 2:
        return <ThirdStepMainBody />;
      default:
        return null;
    }
  };

  return (
    <Paper
      elevation={1}
      sx={{
        padding: { xs: "8px", sm: "10px", md: "12px", lg: "24px", xl: "24px" },
        backgroundColor: (theme) => theme.palette.background.paper,
        boxShadow: (theme) =>
          theme.palette.mode === "dark"
            ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
            : "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {renderStepContent()}
    </Paper>
  );
};

export default TemplateMainBody;
